import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';
import { Whitespace, Text } from './common';
import { HowItWorksItem } from '../routes/static/how-it-works/HowItWorks';

export default class HowItCarousel extends React.Component {
  render() {
    const { owner } = this.props;
    return (
      <Carousel
        className="f f-cc h-325 w-250 home-how-carousel"
        interval={null}
        wrap={false}
        nextIcon={
          <div className="f f-cc coolGrayLight h-99p">
            <i className="fal fa-angle-right " />
          </div>
        }
        prevIcon={
          <div className="f f-cc coolGrayLight h-99p">
            <i className="fal fa-angle-left" />
          </div>
        }
      >
        {owner ? ownerCarousel : renterCarousel}
      </Carousel>
    );
  }
}

const renterCarousel = [
  <Carousel.Item key={1}>
    <HowItWorksItem
      icon="clipboard-list"
      num="1"
      name="Search"
      text1="Browse listings by"
      text2="keyword or category."
      owner
    />
  </Carousel.Item>,
  <Carousel.Item key={2}>
    <HowItWorksItem
      icon="calendar-check"
      num="2"
      name="Reserve"
      text1="Select an item and the"
      text2="dates you'd like to use it."
      owner
    />
  </Carousel.Item>,
  <Carousel.Item key={3}>
    <HowItWorksItem
      icon="snowboarding"
      num="3"
      name="Enjoy"
      text1="Pickup your rental item"
      text2="then have fun!"
      owner
    />
  </Carousel.Item>,
  <Carousel.Item key={3}>
    <HowItWorksItem
      icon="repeat"
      num="4"
      name="Return"
      text1="Return the item to the"
      text2="owner then leave a review."
      owner
    />
  </Carousel.Item>,
];

const ownerCarousel = [
  <Carousel.Item key={1}>
    <HowItWorksItem
      icon="plus-square"
      num="1"
      name="List"
      text1="Create listings for anything"
      text2="that you own."
    />
  </Carousel.Item>,
  <Carousel.Item key={2}>
    <HowItWorksItem
      icon="comment-check"
      num="2"
      name="Approve"
      text1="Respond to and approve"
      text2="rental requests."
    />
  </Carousel.Item>,
  <Carousel.Item key={3}>
    <HowItWorksItem
      icon="people-carry"
      num="3"
      name="Rent"
      text1="Rent our your things"
      text2="to people in your area."
    />
  </Carousel.Item>,
  <Carousel.Item key={3}>
    <HowItWorksItem
      icon="usd-circle"
      num="4"
      name="Earn"
      text1="Make money every time"
      text2="your items are used"
    />
  </Carousel.Item>,
];



// WEBPACK FOOTER //
// ./src/components_new/HowItCarousel.js